<script setup lang="ts">
import { ref } from "vue";
import { resetPassword } from "../../auth/api";
import { t } from "../../i18n";
import { appStore } from "../../stores/app";

const password = ref("");
const confirmPassword = ref("");
/** Translation keys of the validation errors to show */
const errors = ref<string[]>([]);

async function submit() {
    errors.value = [];

    if (!password.value || !confirmPassword.value) {
        errors.value.push("page.resetpassword.novalues");
    }
    // Kept from the old code: the comparison ignores upper/lower case
    if (password.value.toLowerCase() !== confirmPassword.value.toLowerCase()) {
        errors.value.push("page.resetpassword.nomatch");
    }
    if (errors.value.length > 0) return;

    const token = new URL(window.location.href).searchParams.get("token");
    const status = await resetPassword(password.value, confirmPassword.value, token);

    if (status === 200) {
        appStore.modal = "resetPasswordConfirmation";
    }
    if (status === 401) {
        window.location.href = "/";
    }
}
</script>

<!-- Shown when appStore.page is "resetpassword" (set by showPage in app.ts) -->
<template>
    <div class="resetpassword-page page bulma-contextual" data-page="resetpassword" :class="{ 'is-shown': appStore.page === 'resetpassword' }">
        <div class="page__content columns is-gapless is-centered is-vcentered">
            <div class="column is-12-mobile is-10-tablet">
                <div class="columns is-gapless">
                    <div class="column is-12-mobile is-6-tablet is-3-widescreen">
                        <div class="login">
                            <section class="section">
                                <div class="mb-6">

                                    <h1 class="title is-1" v-html="t('page.resetpassword.header')"></h1>
                                    <p class="mb-6" v-html="t('modal.resetpassword.body')"></p>
                                    <div class="simple-input field">
                                        <div class="control">
                                            <input id="resetpassword" v-model="password" name="resetpassword" type="password" class="input is-shadowless is-radiusless" :placeholder="t('page.resetpassword.password')" />
                                        </div>
                                    </div>
                                    <div class="simple-input field">
                                        <div class="control">
                                            <input id="resetpassword2" v-model="confirmPassword" name="resetpassword2" type="password" class="input is-shadowless is-radiusless" :placeholder="t('page.resetpassword.password2')" />
                                        </div>
                                    </div>
                                    <ul id="resetpassword-errors" class="mb-6">
                                        <li v-for="error in errors" :key="error" v-html="t(error)"></li>
                                    </ul>
                                    <div class="field">
                                        <div class="control">
                                            <button class="resetpassword-btn button is-default is-dark is-radiusless is-fullwidth" @click="submit">
                                                <span v-html="t('page.resetpassword.header')"></span>
                                                <span class="icon is-small is-right">
                                                    <i class="fas fa-long-arrow-alt-right"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
